import React, { useEffect }  from 'react'
import '../../assets/assets/scss/pages/_landing_page.scss'
import LandingPageItems from './components/landingPageItems'
import {dashboardItems} from './constants/items'
import {  useDispatch, useSelector } from 'react-redux'
import { permissionsList, permissionsWithAssignedIds } from '../../api/constant'
import { hasPermission } from '../../utils/common'
import dayjs from "dayjs"
import { resetAndrologyData } from '../../actions/andrologyAction'
import { resetPatientData } from '../../actions'

export default function LandingPage() {
    const [landingPageItems,setLandingPageItems] = React.useState(dashboardItems)
    const userName = useSelector(state => state.loginReducer.user?.firstName);
    const permissionMap = useSelector(state => state.loginReducer.permissionsMap);
    const isProfileFetched = useSelector(state => state.loginReducer.isProfileFetched);
    const dispatch = useDispatch();

    useEffect(() => {
      dispatch(resetAndrologyData());
      dispatch(resetPatientData());
    }, [dispatch]);
  
    const greeting = () => {
      const currentTime = dayjs().hour();
      if (currentTime < 12) {
        return 'Good morning!';
      } else if (currentTime < 18) {
        return 'Good afternoon!';
      } else {
        return 'Good evening!';
      }
    };
  
    const renderLandingPageItems = () => {
      if (!landingPageItems || !landingPageItems.length) {
        return <p>No data found</p>;
      }
  
      return landingPageItems
        .filter((item) =>
          item.requiredPermission
            ? hasPermission(permissionMap, item.requiredPermission)
            : true
        )
        .map((item, index) => (
          <LandingPageItems
            key={index}
            icon={item.icon}
            title={item.title}
            link={item.link}
            description={item.description}
          />
        ));
    };
  
    return (
      <div className='landing_page_container'>
        {isProfileFetched && (
          <>
            <div className='landing_page_header'>
              <h1>{greeting()}, {userName}!</h1>
            </div>
            <div className='flex_container'>
              {renderLandingPageItems()}
            </div>
          </>
        )}
      </div>
    );
  }